// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gruTF1Tp1GZ04JsqK2tJ {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
}

.R1Avc20YZk3zksphHg35 {
  overflow-y: auto;
  height: calc(100vh - 18rem);
}

.v6C1WwIT5BWr51S3u9y0 {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.q9w_QRlV_GXOeWuN2wOY {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/screens/RaffleAdministration/Raffles.module.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,2BAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAJ","sourcesContent":["\r\n.idoAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n}\r\n\r\n.idoTableContainer {\r\n    overflow-y: auto;\r\n    height: calc(100vh - 18rem);\r\n}\r\n\r\n.idoTableFooter {\r\n    width: 100%;\r\n    height: 50px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.editIDOContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"idoAdminContainer": `gruTF1Tp1GZ04JsqK2tJ`,
	"idoTableContainer": `R1Avc20YZk3zksphHg35`,
	"idoTableFooter": `v6C1WwIT5BWr51S3u9y0`,
	"editIDOContainer": `q9w_QRlV_GXOeWuN2wOY`
};
export default ___CSS_LOADER_EXPORT___;
